/*eslint-disable */
export default {
    'SOUND':                            'Sound',
    'MSG_INCORRECT_PASSWORD':           'This password is not correct.',
    'MSG_EMAIL_NOT_REGISTERED':         'This email is not registered.',
    'MSG_EMAIL_IN_USE':                 'The specified email address is already in use.',
    'MSG_EMAIL_BLANK':                  'Email cannot be blank.',
    'MSG_PASSWORD_BLANK':               'Password cannot be blank.',
    'MSG_NAME_BLANK':                   'Name cannot be blank.',
    'Self-service':                     'Self-service',
    'Baking courses':                   'Baking courses',
    'Bigger oven':                      'Bigger oven',
    'Pastry chef':                      'Pastry chef',
    'Wholesale bakery':                 'Wholesale bakery',
    'Franchise bakery':                 'Franchise bakery',
    'Fettes Brot':                      'Fettes Brot',
    'Bio grade bread':                  'Bio grade bread',
    'Locally milled flour':             'Locally milled flour',
    'Bakerman is baking bread':         'Bakerman is baking bread',
    'Coffee shop':                      'Coffee shop',
    'Bockwurst with bread':             'Bockwurst with bread',
    'Sandwiches':                       'Sandwiches',
    'Gluten-free goods':                'Gluten-free goods',
    'Cheese analogue':                  'Cheese analogue',
    'Wedding cakes':                    'Wedding cakes',
    'Pizza world champion':             'Pizza world champion',
    'Cheese crust':                     'Cheese crust',
    'Peel':                             'Peel',
    'Pizza cutter':                     'Pizza cutter',
    'Verace Pizza Napoletana':          'Verace Pizza Napoletana',
    'Frozen pizza':                     'Frozen pizza',
    'Car':                              'Car',
    'Helicopter':                       'Helicopter',
    'Instant pizza':                    'Instant pizza',
    'Low-carb':                         'Low-carb',
    'Scooter':                          'Scooter',
    'Printed menus':                    'Printed menus',
    'Real italian cook':                'Real italian cook',
    'Cheap paper pizza boxes':          'Cheap paper pizza boxes',
    'Native olive oil':                 'Native olive oil',
    'Crossword puzzle':                 'Crossword puzzle',
    'Pulitzer Prize':                   'Pulitzer Prize',
    'Editorial department':             'Editorial department',
    'TV programme':                     'TV programme',
    'Horoscope':                        'Horoscope',
    'Foreign correspondent':            'Foreign correspondent',
    'Economy section':                  'Economy section',
    'Obituaries':                       'Obituaries',
    'Sports section':                   'Sports section',
    'Feuilleton':                       'Feuilleton',
    'Nationwide delivery':              'Nationwide delivery',
    'Printing press':                   'Printing press',
    'Self publishing':                  'Self publishing',
    'Digital issue':                    'Digital issue',
    'Bottling plant':                   'Bottling plant',
    'More flavors':                     'More flavours',
    'Addition of caffeine':             'Addition of caffeine',
    'Forged health study':              'Faked health study',
    'BOGOF':                            'BOGOF',
    'Crystal lemonade':                 'Crystal lemonade',
    'Light lemonade':                   'Light lemonade',
    'Car manufacturer':                 'Car manufacturer',
    'CarManufacturer':                  'Car manufacturer',
    'RANKING':                          'Ranking',
    'CONNECT_FACEBOOK':                 'Connect with Facebook',
    'CONNECT_GPLUS':                    'Connect with Google+',
    'CONNECT_TWITTER':                  'Connect with Twitter',
    'TUTORIAL_STEP1_TITLE':             'Buy a shop',
    'TUTORIAL_STEP1_TEXT':              'Click the \'Shops\' tab.',
    'TUTORIAL_STEP2_TITLE':             'Lemonade stand',
    'TUTORIAL_STEP2_TEXT':              'Click the buy button to buy a lemonade stand.',
    'TUTORIAL_STEP3_TITLE':             'Produce',
    'TUTORIAL_STEP3_TEXT':              'Click the icon to produce lemonade and earn money.',
    'TUTORIAL_STEP4_TITLE':             'More branches!',
    'TUTORIAL_STEP4_TEXT':              'Build more branches to increase your earnings.',
    'TUTORIAL_STEP5_TITLE':             'Mo money',
    'TUTORIAL_STEP5_TEXT':              'Keep producing until you have $60',
    'TUTORIAL_STEP6_TITLE':             'Pager delivery',
    'TUTORIAL_STEP6_TEXT':              'Click the buy button to bay a paper delivery',
    'TUTORIAL_STEP7_TITLE':             'Mo money',
    'TUTORIAL_STEP7_TEXT':              'Keep producing with all your shops until you have $1000.',
    'TUTORIAL_STEP8_TITLE':             'Hire manager',
    'TUTORIAL_STEP8_TEXT':              'Click the \'Manager\' tab',
    'TUTORIAL_STEP9_TITLE':             'Lemonade stand manager',
    'TUTORIAL_STEP9_TEXT':              'Click the hire button to hire a manager for your lemonade stand.',
    'TUTORIAL_STEP10_TITLE':             'Produce',
    'TUTORIAL_STEP10_TEXT':              'Go back to the shops tab.',
    'TUTORIAL_STEP11_TITLE':             'Automatic production',
    'TUTORIAL_STEP11_TEXT':              'Produce lemonade again. When finished, your manager will overtake production.',
    'TUTORIAL_FINISHED_HEADLINE':       'Tutorial finished',
    'TUTORIAL_FINISHED_TEXT':           'Congratulation - you now know how to play. Keep buying shops and building branches. You should also look at the upgrades. Good luck!',
    'NO':                               'No',
    'YES':                              'Yes',
    'DELETE_CONFIRM':                   'Are you really sure? All game data will be deleted.',
    'MANAGER_ALREADY_HIRED':            'already hired',
    'UPGRADE_ALREADY_APPLIED':          'already bought',
    'AMOUNTTOBUILD':                    'Build',
    'Flood damage':                     'Flood damage',
    'UPGRADE_DECREASE_PRODUCTION_TIME': 'Decreases the production time for {shop} by {factor}',
    'UPGRADE_INCREASE_EARNINGS':        'Increases the earnings for {shop} by {factor}',
    'Bank':                             'Bank',
    'Airline':                          'Airline',
    'LemonadeStand':                    'Lemonade stand',
    'Lemonade stand':                   'Lemonade stand',
    'PaperDelivery':                    'Paper delivery',
    'Paper delivery':                   'Pager delivery',
    'Soccer team':                      'Soccer team',
    'SoccerTeam':                       'Soccer team',
    'Movie studio':                     'Movie studio',
    'MovieStudio':                      'Movie studio',
    'SocialNetwork':                    'Social network',
    'Social network':                   'Social network',
    'LampStore':                        'Lamp store',
    'Lamp store':                       'Lamp store',
    'Bakery':                           'Bakery',
    'Shoe shop':                        'Shoe shop',
    'ShoeShop':                         'Shoe shop',
    'Pizza delivery':                   'Pizza delivery',
    'PizzaDelivery':                    'Pizza delivery',
    'Drug ring':                        'Drug ring',
    'DrugRing':                         'Drug ring',
    'RESET_GAME':                       'Reset game',
    'CONNECTION_FOUND':                 'You can continue earning money.',
    'CONNECTION_FOUND_HEADLINE':        'Connection re-established.',
    'CONNECTION_LOST':                  'The game cannot continue like this. Please wait.',
    'CONNECTION_LOST_HEADLINE':         'Connection to sever lost!',
    'HELLO':                            'Hello {name}',
    'WELCOMEMSG':                       'Welcome to MEANager',
    'HOWTOPLAY':                        'How to play',
    'HOWTOPLAY_STEP1':                  'Build new shops in the \'Shops\' tab.',
    'HOWTOPLAY_STEP2':                  'Produce goods and earn money.',
    'HOWTOPLAY_STEP3':                  'Hire managers who take over the production for you.',
    'HOWTOPLAY_STEP4':                  'Improve your shops in the \'Upgrade\' tab.',
    'HOWTOPLAY_STEP5':                  'Build more branches.',
    'HOWTOPLAY_STEP6':                  'Hope, that nothing bad will happen to you.',
    'HOWTOPLAY_STEP7':                  'Earn as much money as possible.',
    'EARNINGSFOR':                      'Earnings for',
    'LOGINDESCRIPTION':                 'If you are already registered, you can login here.',
    'SIGNUPDESCRIPTION':                'Continue your game from any device when you are registered and logged in.',
    'ACHIEVEMENTSDESCRIPTION':          'Look what you have achieved already.',
    'STATISTICSDESCRIPTION':            'Some statistical data.',
    'MANAGERSDESCRIPTION':              'These guys help you producing stuff.',
    'SHOPSDESCRIPTION':                 'Look at what you have built.',
    'UPGRADESDESCRIPTION':              'Improve your shops with these helpful upgrades.',
    'SHOPSHEADING':                     'Shops',
    'PASSWORDINCORRECT':                'Incorrect password',
    'PASSWORDCHANGEOK':                 'Password successfully changed.',
    'CHANGEPASSWORD':                   'Change password',
    'SAVECHANGES':                      'Save changes',
    'CURRENTPASSWORD':                  'Current password',
    'NEWPASSWORD':                      'New password',
    'NAMEREQUIRED':                     'A name is required',
    'PASSWORDMINTEXT':                  'Password must be at least 3 characters.',
    'GIVEMEYOURMAIL':                   'What\'s your email address?',
    'NAME':                             'Name',
    'INVALIDMAIL':                      'Doesn\'t look like a valid email.',
    'EMAIL':                            'Email',
    'PASSWORD':                         'Password',
    'GONEFOR':                          'You were gone {time}.',
    'INCOMEGENERATEDWHILEGONE':         'You earned {income} while you were away.',
    'HIRE_FOR':                         'Hire for {costs}',
    'MANAGEDBY':                        'Managed by {manager}',
    'allShops':                         'all shops',
    'BUYFOR':                           'buy for {costs}',
    'BUYXFOR':                          'Buy {amount} x for {price}',
    'UPGRADE':                          'Upgrade',
    'UPGRADES':                         'Upgrades',
    'LOGIN':                            'Log in',
    'LOGOUT':                           'Logout',
    'SIGNUP':                           'Sign up',
    'MANAGER':                          'Manager',
    'MANAGERS':                         'Managers',
    'STATISTICS':                       'Statistics',
    'ACHIEVEMENTS':                     'Achievements',
    'ACHIEVEMENT':                      'Achievement',
    'RESTART':                          'Restart',
    'CLOSE':                            'Close',
    'FOR':                              'for',
    'APP_HEADLINE':                     'Awesome AngularJS App',
    'NAV_HOME':                         'Start',
    'NAV_ABOUT':                        'About',
    'APP_TEXT':                         'Some text about the awesome AngularJS app.',
    'BUTTON_TEXT_EN':                   'EN',
    'BUTTON_TEXT_DE':                   'DE',
    'NUM1E06':                          'Million',
    'NUM1E09':                          'Billion',
    'NUM1E12':                          'Trillion',
    'NUM1E15':                          'Quadrillion',
    'NUM1E18':                          'Quintillion',
    'NUM1E21':                          'Sextillion',
    'NUM1E24':                          'Septillion',
    'NUM1E27':                          'Octillion',
    'NUM1E30':                          'Nonillion',
    'NUM1E33':                          'Decillion',
    'NUM1E36':                          'Undecillion',
    'NUM1E39':                          'Duodecillion',
    'NUM1E42':                          'Tredecillion',
    'NUM1E45':                          'Quattuordecillion',
    'NUM1E48':                          'Quindecillion',
    'NUM1E51':                          'Sexdecillion',
    'NUM1E54':                          'Septendecillion',
    'NUM1E57':                          'Octodecillion',
    'NUM1E60':                          'Novemdecillion',
    'NUM1E63':                          'Vigintillion',
    'NUM1E66':                          'Unvigintillion',
    'NUM1E69':                          'Duovigintillion',
    'NUM1E72':                          'Tresvigintillion',
    'NUM1E75':                          'Quattuorvigintillion',
    'NUM1E78':                          'Quinquavigintillion',
    'NUM1E81':                          'Sesvigintillion',
    'NUM1E84':                          'Septemvigintillion',
    'NUM1E87':                          'Octovigintillion',
    'NUM1E90':                          'Novemvigintillion',
    'NUM1E93':                          'Trigintillion',
    'NUM1E96':                          'Untrigintillion',
    'NUM1E99':                          'Duotrigintillion',
    'NUM1E100':                         'Googol',
    'CURRENCY':                         'USD',
    'TOGGLENAV':                        'Toggle navigation',
    'SHOP_02_NAME':                     'Paper Delivery',
    'SHOP_03_NAME':                     'Car wash',
    'MANAGER_00_DESC':                  'The king of whittling. For a small fee he will be willing to help you grow your business.',
    'MANAGER_01_DESC':                  'Disgraced herself at her former job, but can throw really far.',
    'MANAGER_02_DESC':                  'Wears shoes himself.',
    'MANAGER_03_DESC':                  'Played Pizza Connection in the nineties.',
    'MANAGER_04_DESC':                  'Some say he is a clown. But he isn\'t funny at all.',
    'MANAGER_05_DESC':                  'No one bakes faster.',
    'MANAGER_06_DESC':                  'Drives a big BMW and smokes like a chimney but orders and makes phone calls like no other.',
    'MANAGER_07_DESC':                  'Has been a club member for years and is its biggest fan.',
    'MANAGER_08_DESC':                  'The action specialist directly from Hollywood.',
    'MANAGER_09_DESC':                  'Flight pioneer, has flight training and a degree in flight sciences.',
    'MANAGER_10_DESC':                  'Almost no previous convictions and he knows the chancellor.',
    'MANAGER_11_DESC':                  'Follows a long family history in car manufacturing.',
    'MANAGER_12_DESC':                  'Hist enemies just call him \'The club\'. His friends also.',
    'SHOP_AUTOUPGRADE_COOLDOWN_MSG':    'Production time for {shopName} sped up by factor {factor}!',
    'SHOP_AUTOUPGRADE_EARNINGS_MSG':    'Earnings for {shopName} x {factor}!',
    'NODATATEXT':                       'No data available',
    'MANAGE_TEXT':                      'Manages the {shopType}.',
    'No data available':                'No data available',
    'LIFETIME_EARNINGS':                'Lifetime earnings',
    'SESSION_EARNINGS':                 'Session earnings',
    'EDIT':                             'Edit',
    'UPGRADE_POSITIVE':                 'Yeah!',
    'UPGRADE_NEGATIVE':                 'Oh no!',
    'earnings':                         'Earnings',
    'for':                              'for',
    'productionTime':                   'Production time',
    'SHOPS':                            'Shops',
    'ACHIEVEDATE':                      'Achieved at',
    'NOTACHIEVED':                      'Not achieved yet',
    'ACHIEVEMENT_BRANCHES':             'Get {branches} branches of every shop.',
    'ACHIEVEMENT_BALANCE':              'Own more then {balance}.',
    'UpgradeShowIncomePerSecond':       'Income/s',
    'Bulk order':                       'Bulk order',
    'Antique oil lamps':                'Antique oil lamps',
    'Grow lamps':                       'Grow lamps',
    'Industrial lighting':              'Industrial lighting',
    'Power generating lights':          'Power generating lights',
    'Gas lights':                       'Gas lights',
    'Darklights':                       'Darklights',
    'Superluminal velocity lights':     'Superluminal velocity lights',
    'Fitness coach':                    'Fitness coach',
    'Medical team':                     'Medical team',
    'Robots team':                      'Robots team',
    'Press department':                 'Press department',
    'PR tour through Asia':             'PR tour through Asia',
    'Sporting director':                'Sporting director',
    'Doping':                           'Doping',
    'Intercontinental Cup winner':      'Intercontinental Cup winner',
    'Become FIFA president':            'Become FIFA president',
    'Move up the league':               'Move up the league',
    'Star trainer':                     'Star trainer',
    'Advertising boards':               'Advertising boards',
    'Main sponsor':                     'Main sponsor',
    'Champions League':                 'Champions League',
    'Women\'s team':                    'Women\'s team',
    'International merchandise':        'International merchandise',
    'League winner':                    'League winner',
    'Talent scouts':                    'Talent scouts',
    'Initial public offering':          'Initial public offering',
    'Sexy stewardesses':                'Sexy stewardesses',
    'Sexy stewards':                    'Sexy stewards',
    'Charter flights':                  'Charter flights',
    'Own airport':                      'Own airport',
    'Package holidays':                 'Package holidays',
    'More legroom':                     'More legroom',
    'Autopilot':                        'Autopilot',
    'Tomato juice':                     'Tomato juice',
    'Tax free shopping':                'Tax free shopping',
    'Miles bonus program':              'Miles bonus program',
    'Solar planes':                     'Solar planes',
    'In-flight entertainment':          'In-flight entertainment',
    'Internet access':                  'Internet access',
    'Business class':                   'Business class',
    'Flight to the moon':               'Flight to the moon',
    'ATMs':                             'ATMs',
    'Stock trading':                    'Stock trading',
    'Safe deposit boxes':               'Safe deposit boxes',
    'Insurances':                       'Insurances',
    'Call center':                      'Call center',
    'Online banking':                   'Online banking',
    'Phone banking':                    'Phone banking',
    'Investment banking':               'Investment banking',
    'Big bank':                         'Big bank',
    'Transaction fees':                 'Transaction fees',
    'Assembly lines':                   'Assembly lines',
    'Welding robots':                   'Welding robots',
    'Self-driving cars':                'Self-driving cars',
    'Airbags':                          'Airbags',
    'ESP':                              'ESP',
    'ABS':                              'ABS',
    'Bio fuel powered cars':            'Bio fuel powered cars',
    'Electric cars':                    'Electric cars',
    'Luxury brand':                     'Luxury brand',
    'Supersonic car':                   'Supersonic car',
    'Flying car':                       'Flying car',
    'Limousine':                        'Limousine',
    'Family van':                       'Family van',
    'SUV':                              'SUV',
    'Plane':                            'Plane',
    'Netflix series':                   'Netflix series',
    'Amphibious vehicles':              'Amphibious vehicles',
    'Convertible':                      'Convertible',
    'Car rental':                       'Car rental',
    'Leasing':                          'Leasing',
    'Unflattable tires':                'Unflattable tires',
    'Car museum':                       'Car museum',
    'Racing team':                      'Racing team',
    'Drug lab':                         'Drug lab',
    'Own country':                      'Own country',
    'Bulk pack smuggle condoms':        'Bulk pack smuggle condoms',
    'Marihuana legalization':           'Marihuana legalization',
    'Speedboat':                        'Speedboat',
    'Opium poppy fields':               'Opium poppy fields',
    'Greenhouse':                       'Greenhouse',
    'Automatic weapons':                'Automatic weapons',
    'Counterfeited drugs':              'Counterfeited drugs',
    'Smuggle tunnel':                   'Smuggle tunnel',
    'Invisibility cloak':               'Invisibility cloak',
    'Get rid of competitor':            'Get rid of competitor',
    'Bribes':                           'Bribes',
    'Goon squad':                       'Goon squad',
    'Killer commando':                  'Killer commando',
    'CHEATER_MSG_BODY':                 'Your save game was modified... So you have to restart.',
    'CHEATER_MSG_HEADING':              'Cheating attempt detected!',
    'Strike!':                          'Strike!',
    'Strike':                           'Strike',
    'ON_STRIKE_FOR':                    'No production for {duration} seconds.',
    'FOR_SHOP':                         'for {shop}',
    'EVT_FIRE':                         'Fire at the {shop}!',
    'EVT_BOOST':                        'Turbo boost!',
    'EVT_GENERAL_REPAIRS':              'Make general repairs on all of your shops. For each shop pay {singleCost}.',
    'EVT_BEAUTY_CONTEST':               'You have won third prize in a beauty contest.',
    'EVT_CROSSWORD':                    'You have won a crossword competition.',
    'EVT_FLOOD':                        'Flood damage',
    'EVT_SHOP_USEBILITY':               'You won a shop usability contest.',
    'EVT_CEASE_DESIST':                 'Cease and desist letter',
    'EVT_BANK_ERROR_NOT_FAVOR':         'Bank error against your favour',
    'EVT_BANK_ERROR_FAVOR':             'Bank error in your favour',
    'EVT_JACKPOT':                      'Jackpot!',
    'EVT_ROBBERY':                      'Robbery!',
    'EVT_STRIKE':                       'Strike!',
    'Social media expert':              'Social media expert',
    'YOUR_STATS':                       'Your points: {points}',
    'PLAYER_COUNT':                     'Players online: {count}',
    'PLAYER':                           'Player',
    'POINTS':                           'Points',
    'DATE':                             'Date',
    'HIDE_APPLIED':                     'Hide applied',
    'ACHIEVEMENT_TITLE':                '{amount} x {shop}',
    'HIDE_ACHIEVED':                    'Hide achieved',
    'GENERAL':                          'general',
    'WAITING_FOR_SERVER':               'Waiting for server connection...',
    'Missing credentials':              'Missing credentials',
    'Path `email` is required.':         'Email missing'
}
